"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _headline = _interopRequireDefault(require("../../components/headline"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  departmentTitle: {
    ...theme.customTypography.teamDepartmentTitle
  },
  employee: {
    alignItems: "center",
    background: theme.palette.background.light,
    padding: theme.spacing(2, 3)
  },
  link: {
    color: "inherit",
    display: "block",
    position: "relative"
  },
  employeeTitle: {
    ...theme.customTypography.teamEmployeeTitle
  },
  image: {
    borderRadius: "50%",
    display: "block",
    height: "100%",
    maxHeight: 120,
    maxWidth: 120,
    objectFit: "cover",
    width: "100%"
  },
  imagePlaceholder: {
    background: "rgba(255, 255, 255, 0.6)",
    borderRadius: "50%",
    height: 120,
    width: 120
  },
  contentWrapper: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  arrow: {
    position: "absolute",
    right: theme.spacing(2),
    top: "50%",
    transform: "translate(0, -50%)"
  }
}));
let departmentsWithEmployees = [];
const Department = _ref => {
  let {
    departmentID,
    lang,
    providers
  } = _ref;
  const [departmentAndEmployees, setDepartmentAndEmployees] = (0, _react.useState)([]);
  const [headline, setHeadline] = (0, _react.useState)("");
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  departmentID = +departmentID;
  departmentsWithEmployees = [];
  (0, _react.useEffect)(() => {
    async function fetchData() {
      Promise.all([loadDepartments(lang, providers), loadEmployees(departmentID, lang)]).then(values => {
        var _departments$groups;
        const [departments, employees] = values;
        const mainGroup = findDepartments(departments === null || departments === void 0 || (_departments$groups = departments.groups) === null || _departments$groups === void 0 ? void 0 : _departments$groups.items, departmentID);
        addDepartmentsToArray(mainGroup);
        if (mainGroup.length > 0) {
          // find and add subgroups

          const subGroups = findDepartments(mainGroup[0].items);
          addDepartmentsToArray(subGroups);

          // add employees to departments

          addEmployeesToDepartments(employees);

          // set state

          setDepartmentAndEmployees(departmentsWithEmployees);

          // set headline

          setHeadline(mainGroup[0].title);
        }
      });
    }
    fetchData();
  }, [departmentID, lang, providers]);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const ParsedDeparturesWithEmployees = departmentAndEmployees.map((department, counter) => {
    return /*#__PURE__*/_react.default.createElement(DepartmentItem, {
      key: counter,
      data: department
    });
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_headline.default, {
    data: {
      text: headline
    }
  }), ParsedDeparturesWithEmployees);
};
const DepartmentItem = props => {
  const {
    data
  } = props;
  const css = useStyles();
  if (!data.employees || data.employees.length < 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const title = /*#__PURE__*/_react.default.createElement("div", {
    className: css.departmentTitle
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: data.title
    }
  }));
  const employees = data.employees.map(employee => {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: employee.id,
      item: true,
      xs: 12,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(Employee, {
      data: employee,
      currentGroupID: data.id
    }));
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, employees));
};
const Employee = props => {
  const {
    currentGroupID
  } = props;
  const {
    firstName,
    groups,
    lastName,
    media,
    pageName
  } = props.data;
  const css = useStyles();
  let name = null;
  if (firstName && lastName) {
    name = firstName + " " + lastName;
  } else if (firstName) {
    name = firstName;
  } else if (lastName) {
    name = lastName;
  }
  const m = (0, _lodash.first)(media);
  let image = null;
  if (m && m.filename) {
    image = /*#__PURE__*/_react.default.createElement("img", {
      className: css.image,
      src: m.filename,
      alt: name,
      loading: "lazy"
    });
  } else {
    image = /*#__PURE__*/_react.default.createElement("div", {
      className: css.imagePlaceholder
    });
  }
  const currentDepartment = groups.find(item => {
    if (item.id === currentGroupID) {
      return item;
    }
    return null;
  });
  let jobTitle = null;
  if (currentDepartment && currentDepartment.addition) {
    jobTitle = currentDepartment.addition;
  }
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: css.link,
    to: pageName
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.employee
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, image), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9,
    className: css.contentWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.employeeTitle,
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: jobTitle
    }
  }))), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.arrow,
    src: "/img/icons/arrow-right.svg",
    color: "primary",
    size: 24
  }));
};
function findDepartments(item, id) {
  const x = item === null || item === void 0 ? void 0 : item.filter(o => {
    if (id && o.id === id) {
      return o;
    } else if (id && o.id !== id) {
      return null;
    } else {
      return o;
    }
  });
  if (x && x.length > 0) {
    return x;
  }
  return [];
}
function addDepartmentsToArray(groups) {
  if (groups.length >= 0) {
    departmentsWithEmployees.push(...groups);
  }
}
function addEmployeesToDepartments(employees) {
  var _employees$items;
  employees === null || employees === void 0 || (_employees$items = employees.items) === null || _employees$items === void 0 || _employees$items.forEach(employee => {
    var _employee$groups;
    employee === null || employee === void 0 || (_employee$groups = employee.groups) === null || _employee$groups === void 0 || _employee$groups.forEach(employeeGroup => {
      // search group in array

      const arrIndex = departmentsWithEmployees.findIndex(item => {
        return item.id === employeeGroup.id;
      });

      // append to array

      if (arrIndex > -1) {
        (departmentsWithEmployees[arrIndex].employees = departmentsWithEmployees[arrIndex].employees || []).push(employee);
      }
    });
  });
}
async function loadDepartments(lang, providers) {
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const response = await fetch("".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListEmployeeFilter.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(lang));
  return await response.json();
}
async function loadEmployees(departmentID, lang) {
  const {
    REACT_APP_PATH
  } = process.env;
  const response = await fetch("".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListEmployee.api?Groups=").concat(departmentID, "&lang=").concat(lang));
  return await response.json();
}
var _default = exports.default = Department;